import * as React from 'react';
import { connect } from 'react-redux';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox/index';
import { IAppState, Dispatch } from '../../../../common/state';
import { ELandStatusType } from '../../../../json_query';
import { FOfferType } from '../../../../utils/category';
import { changeLandStatus } from '../../../state/advanced/land_status';
import { InlineParam, Row } from '../markup';

interface ILandStatusProps {
  landStatuses: ELandStatusType[];
  onLandStatusChange(landStatusType: ELandStatusType, value: boolean): void;

  offerType: FOfferType;
}

const isLandStatusExists = (existingLandStatusTypes: ELandStatusType[], parking: ELandStatusType): boolean => {
  return existingLandStatusTypes.indexOf(parking) > -1;
};

const LandStatus: React.StatelessComponent<ILandStatusProps> = props => {
  let landStatuses: Array<{ name: string; type: ELandStatusType }> = [
    { name: 'Фермерское хозяйство', type: ELandStatusType.Farm },
    { name: 'Личное подсобное хозяйство', type: ELandStatusType.PrivateFarm },
    { name: 'Садоводство', type: ELandStatusType.Gardening },
    { name: 'ИЖС', type: ELandStatusType.IndividualHousingConstruction },
    { name: 'Земля промназначения', type: ELandStatusType.IndustrialLand },
    { name: 'ДНП', type: ELandStatusType.CountryhouseNonCommercialPartnership },
  ];

  if (props.offerType === FOfferType.Land) {
    landStatuses = landStatuses.concat({ name: 'Инвестпроект', type: ELandStatusType.InvestmentProject });
  }

  return (
    <Row title="Статус участка">
      {landStatuses.map((landStatusProps, i) => (
        <InlineParam key={landStatusProps.name}>
          <ButtonCheckbox
            onValueChange={value => props.onLandStatusChange(landStatusProps.type, value)}
            value={isLandStatusExists(props.landStatuses, landStatusProps.type)}
          >
            {landStatusProps.name}
          </ButtonCheckbox>
        </InlineParam>
      ))}
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    landStatuses: (state.filters.jsonQuery.land_status && state.filters.jsonQuery.land_status.value) || [],
  }),
  (dispatch: Dispatch) => ({
    onLandStatusChange: (landStatusType: ELandStatusType, value: boolean) => {
      dispatch(changeLandStatus(landStatusType, value));
    },
  }),
  (stateProps, dispatchProps, ownProps: { offerType: FOfferType }) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }),
)(LandStatus);
